export const SET_CAT_ID = 'SET_CAT_ID';
export const SET_SEARCHED_WORD = 'SET_SEARCHED_WORD';
export const SET_INITIAL_MAX_PRICE = 'SET_INITIAL_MAX_PRICE';
export const SET_INITIAL_MIN_PRICE = 'SET_INITIAL_MIN_PRICE';
export const SET_LAST_SCROLL_POSITION = 'SET_LAST_SCROLL_POSITION';
